import { Fragment, useEffect } from 'react'
import { signOut } from '../../utils/auth/session'
import {
  clearCookie,
  setCookie,
  deleteLocalStorageExcept,
  getTokenDetails,
  clearNonAwsCookies,
  initializePendo,
} from '../../utils/helper/helper'
import { constants } from '../../utils/constants'
import Loader from '../../components/loader/loader'
import { useConfig } from '../../config'

function refreshBrowserStorage(user: any) {
  signOut()
    .then(() => {
      deleteLocalStorageExcept(
        user ? `brightmlsmenuconfig_${user['custom:MemberMlsId']}` : '',
      )
      sessionStorage.clear()
      clearCookie()
    })
    .catch(() => {
      // Handle Error
      console.log('catch calling')
    })
}

async function signout() {
  const user: any = await getTokenDetails()
  localStorage.removeItem(constants.TOKEN_FIELD)
  localStorage.removeItem(constants.AUTHENTICATION_FIELD)
  setCookie(constants.FRESH_SESSION, '', 0)

  clearNonAwsCookies()

  refreshBrowserStorage(user)
}

export default function Logout() {
  const { config } = useConfig()

  useEffect(() => {
    initializePendo()
    if (config) {
      signout()
    }
  }, [config])
  return (
    <Fragment>
      <Loader />
    </Fragment>
  )
}
